import { DirectoryType } from '../enums/directory-type.enum';
import { DirectoryStatus } from '../enums/directory-status.enum';

export const DIRECTORY_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.directory.v1+json';

export enum DirectoryErrorCode {
  DirectoryAccessNotAuthorised = 12,
  InvalidSuperAdminEmail = 13,
}

export class Directory {
  public id: string;
  public enterpriseId: string;
  public type: DirectoryType;
  public domain: string;
  public status: DirectoryStatus;
  public tenantId?: string;
  /** The email for the domain super admin. */
  public domainAdmin?: string;

  constructor(backEndDirectory?: BackEndDirectory) {
    this.id = backEndDirectory?.id;
    this.enterpriseId = backEndDirectory?.enterprise_id;
    this.type = backEndDirectory?.type;
    this.domain = backEndDirectory?.domain;
    this.status = backEndDirectory?.status;
    this.tenantId = backEndDirectory?.tenant_id;
    this.domainAdmin = backEndDirectory?.domain_admin;
  }

  public toBackend(): BackEndDirectory {
    return {
      id: this.id,
      enterprise_id: this.enterpriseId,
      type: this.type,
      domain: this.domain,
      status: this.status,
      tenant_id: this.tenantId,
      domain_admin: this.domainAdmin,
    };
  }

  public toBackendPatch(): BackEndDirectoryPatch {
    return {
      id: this.id,
      status: this.status,
      tenant_id: this.tenantId,
      domain_admin: this.domainAdmin,
    };
  }
}

export interface BackEndDirectory {
  id: string;
  enterprise_id: string;
  type: DirectoryType;
  domain: string;
  status: DirectoryStatus;
  tenant_id: string;
  domain_admin?: string;
}


export interface BackEndDirectoryPatch {
  id: string;
  status: DirectoryStatus;
  tenant_id: string;
  domain_admin?: string;
}
